import { Component } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
})
export class CreateUserComponent {
  header = this.translate('Add a user');
  links: link[] = [
    { name: 'رجوع', icon: 'pi pi-angle-right', link: '/admin/users' },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('User console'), link: '/admin/users' },
    { name: this.translate('Add a user'), link: '/admin/users/create' },
  ];
  stats: stat[] = [];
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
}
